/**
 * API tags bilingues. L'autocomplete BE matche `label_fr` ET `label_en` —
 * la logique de "recherche bilingue" est entièrement côté serveur, le FE
 * passe juste la query brute.
 */

import { apiClient } from './client'
import type { TagCreateRequest, TagKind, TagResponse } from '@/types/works'

export interface TagListParams {
  q?: string
  kind?: TagKind
  limit?: number
}

export const tagsApi = {
  list: async (params: TagListParams = {}): Promise<TagResponse[]> => {
    const { data } = await apiClient.get<TagResponse[]>('/tags', { params })
    return data
  },

  create: async (payload: TagCreateRequest): Promise<TagResponse> => {
    const { data } = await apiClient.post<TagResponse>('/tags', payload)
    return data
  },
}
